<template>
	<div class="container-modal form-modal" id="step1">
		<div class="container-holder">
			<div class="header-modal">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
						<path
							stroke-width="1.5"
							vector-effect="non-scaling-stroke"
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
						/>
					</svg>
				</div>
				<div class="title">Datele contului</div>

				<div class="description">
					Parola de acces la curs, materiale și bonusuri vor fi transmise pe adresa de email completată în acest formular. În pașii următori vei alege metoda de plată și datele de facturare.
				</div>
			</div>

			<div class="form-section">
				<div class="input-group-tbf w-mob-100" v-bind:class="{ has_error: $v.user.last_name.$error, complete: user.last_name != '' && !$v.user.last_name.$error }">
					<label class="label-input" for="last_name">{{ $t("register.last_name") }}</label>
					<div class="input-box">
						<input id="last_name" type="text" autocomplete="off" class="input-text" v-model="user.last_name" ref="second_input" />
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{ has_error: $v.user.first_name.$error, complete: user.first_name != '' && !$v.user.first_name.$error }">
					<label class="label-input" for="first_name">{{ $t("register.first_name") }}</label>
					<div class="input-box">
						<input id="first_name" type="text" autocomplete="off" class="input-text" v-model="user.first_name" ref="first_input" />
					</div>
				</div>
				<div class="input-group-tbf w-mob-100" v-bind:class="{ has_error: $v.user.email.$error || mail_exists, complete: user.email != '' && !$v.user.email.$error && !mail_exists }">
					<label class="label-input" for="new-email">Email</label>
					<div class="input-box">
						<input id="new-email" type="email" autocomplete="off" class="input-text" v-model="user.email" ref="third_input" />
					</div>
					<div class="error-msg" v-if="mail_exists">{{ $t("validator.email_already_exists") }}</div>
				</div>
				<div class="input-group-tbf w-mob-100" v-bind:class="{ has_error: $v.user.phone.$error, complete: user.phone != '' && !$v.user.phone.$error }">
					<label class="label-input" for="mobile-phone">{{ $t("register.phone") }}</label>
					<div class="input-box">
						<input id="mobile-phone" type="text" autocomplete="off" class="input-text" v-model="user.phone" ref="first_input" />
					</div>
				</div>

				<div class="input-group-tbf w-mob-100 w-tbf-100" v-bind:class="{ has_error: $v.user.country.$error, complete: user.country != '' && !$v.user.country.$error }">
					<label class="label-input" for="country">{{ $t("register.country-placeholder") }}</label>
					<div class="input-box">
						<multiselect
							class="select-tags-tbf"
							v-model="user.country"
							:options="optionsCountries"
							:allow-empty="true"
							:show-labels="false"
							:multiple="false"
							:close-on-select="true"
							track-by="iso"
							label="name"
							:maxHeight="250"
							openDirection="top"
						>
							<template class="no-result" slot="noResult">{{ $t("register.no_result") }}</template>
							<template slot="noOptions">{{ $t("register.empty_list") }}</template>
						</multiselect>
					</div>
				</div>

				<div class="input-group-tbf w-mob-100 w-tbf-100" v-if="user.country.name && user.country.name != 'Romania'">
					<p class="notice-red">
						Această ofertă este exclusiv pentru societăți și persoane fizice din România. Dacă vrei să faci achiziția folosind date din altă țară, te rugăm să ne scrii un email la
						<a href="mailto:contact@tbf.ro">contact@tbf.ro</a> pentru a stabili ce tip de TVA ți se aplică.
					</p>
				</div>
			</div>
			<div class="submit-form" v-if="!user.country.name || user.country.name == 'Romania'">
				<button class="button-submit" id="buttonSubmitStep1" @click="goNextStep">
					<div class="loader-spin" v-if="loadingSubmit"></div>
					<div class="text" v-else>{{ $t("register.button-action") }}</div>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import CloseIcon from "../Icons/Close";
import IconGlobe from "../Icons/Globe";
import IconPlus from "../Icons/Plus";
import IconInfo from "../Icons/Info";
import IconFolder from "../Icons/Folder";
import IconArrow from "../Icons/Arrow";
import IconPeople from "../Icons/People";
import IconCircleCheck from "../Icons/CircleCheck";
import InformationIcon from "../Icons/Information";
import IconEmail from "../Icons/Email";
import IconPassword from "../Icons/Password";
import IconCart from "../Icons/Cart";
import IconPhone from "../Icons/Phone";

import { required, requiredIf, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
	data() {
		return {
			value_language: "",
			error: false,
			optionsLanguage: [],
			errorData: [],
			optionsCountries: [],
			activeTooltip: "",
			privacy: "",
			invalidCui: "",
			auto_mail: "",
			news: "",
			mail_exists: false,
			loadingSubmit: false,
			termsNotAccepted: "",
			arrayTranslations: [
				"register.title_step_1",
				"register.last_name",
				"register.first_name",
				"register.email",
				"register.phone",
				"register.email-placeholder",
				"register.password",
				"validator.password_min_length",
				"register.button-action",
			],
		};
	},
	props: {
		user: Object,
	},
	components: {
		CloseIcon,
		IconPlus,
		IconInfo,
		IconFolder,
		IconArrow,
		IconPeople,
		IconCircleCheck,
		InformationIcon,
		IconEmail,
		IconGlobe,
		IconPassword,
		IconCart,
		IconPhone,
	},
	validations: {
		user: {
			first_name: { required },
			last_name: { required },
			// phone: { required },
			phone: {},
			email: { required, email },
			country: { required },
			// password: {required,minLength: minLength(6)},
			// confirm_password: {required, sameAsPassword: sameAs('password')}
		},
	},
	created() {},
	async mounted() {
		await this.getCountries();
		await this.getLanguages();
		this.user.has_company = true;
		this.user.referral_uuid = this.$route.query.referral ? this.$route.query.referral : false;
		this.user.reducere = this.$route.query.reducere ? this.$route.query.reducere : false;
		this.logoAnim();
	},
	methods: {
		async getCountries() {
			await axios
				.get("/countries-as-array")
				.then(({ data }) => {
					for (var key of Object.keys(data.data)) {
						this.optionsCountries.push({ iso: key, name: data.data[key] });
					}

					this.user.country = this.optionsCountries.find((el) => el.iso == "RO");
				})
				.finally(() => {
					this.loaded = true;
				});
		},
		async getLanguages() {
			await axios.get("/languages").then(({ data }) => {
				this.optionsLanguage = data.data;
				this.value_language = this.optionsLanguage.find((el) => el.name == (this.$route.query.lang ? this.$route.query.lang : "ro"));
				this.user.language = this.value_language.name;
			});
		},
		goNextStep(e) {
			var btnSubmit = document.getElementById("buttonSubmitStep1");
			btnSubmit.disabled = true;
			this.loadingSubmit = true;

			this.$v.$touch();
			if (this.$v.$invalid) {
				btnSubmit.disabled = false;
				this.loadingSubmit = false;
			} else {
				var checkEmail = false;
				axios.get("/email-validation", { params: { email: this.user.email } }).then(({ data }) => {
					if (!data.data.is_valid) {
						this.errorData["email"] = true;
						this.mail_exists = true;
						btnSubmit.disabled = false;
						this.loadingSubmit = false;
					} else {
						btnSubmit.disabled = false;
						this.user.newPrices = [];
						this.user.coupon = null;
						this.$emit("next_step", { user: this.user, next_step: 21 });
					}
				});
			}
		},
		selectLanguage(value, id) {
			this.user.language = value.name;
		},
		closeModal() {
			this.$router.push("/login");
		},
		checkInputs() {
			var notEmpty = false;

			if (this.user.first_name != "" || this.user.last_name != "") {
				notEmpty = true;
			}

			return notEmpty;
		},
		handleAnimationLogo(anim) {
			this.anim_logo = anim;
			this.anim_logo.setSpeed(1);
		},
		logoAnim() {
			// if(this.finished && !this.bird_noti){
			// 	this.finished = false;
			// 	this.anim_logo.play();
			// 	setTimeout(() => {
			// 		this.anim_logo.stop();
			// 		this.finished = true;
			// 	}, 5000);
			// }
		},
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>
